/* front end application config */

/* Load environment-specific configuration */
let envConfig
try {
  // BUILD_ENV is set by build.sh script during build time
  const BUILD_ENV = process.env.BUILD_ENV || 'production'
  envConfig = require(`./env.${BUILD_ENV}.js`)
  console.log(`Loaded ${BUILD_ENV} environment configuration`)
} catch (error) {
  console.warn('Failed to load environment config, using staging as default')
  envConfig = require('./env.staging.js')
}

module.exports = {
  // app configs
  APP_VER: '2.0',
  API_URL: envConfig.API_URL,
  ADMIN_CORNER_URL: envConfig.ADMIN_CORNER_URL,
  FM_SPACES_BASE_URL: envConfig.FM_SPACES_BASE_URL,
  APP_DIR: '',
  STATIC_FILES_DIR: envConfig.STATIC_FILES_DIR,
  ASSET_FILES_DIR: envConfig.ASSET_FILES_DIR,
  // User and community details
  USER_ID: '',
  CUST_ID: '',
  PUSH_SUB: '',
  ALL_UNITS: [],
  UNITS: [],
  UNIT_ID_LIST: '',
  USER_HAS_MORE_UNITS: false,
  PRIVATE_UNITS: [],
  PRIVATE_UNIT_ID_LIST: '',
  USER_HAS_MORE_PRIVATE_UNITS: false,
  COMM_ID: '',
  LAST_COMM_ID: '',
  COMM_NAME: '',
  MOBILE_NO: '',
  CUST_NAME: '',
  EMAIL_ID: '',
  ROLE_NAME: '',
  IS_FM: false,
  IS_OTHER_USER: false,
  AVATAR_URL: '',
  IS_ADMIN: false,
  IS_USER_ACTIVE: false,
  IS_USER_LINKED: false,
  IS_USER_EMPOWERED: false,
  HIDE_CONTACT: false,
  // Localization
  COMM_COUNTRY_CODE: 'IN',
  IS_TAX_APP: true,
  CURRENCY: '₹ ',
  TAX_EXEMPTION_LIMIT: 7500,
  YEARLY_TAX_EXEMPTION_LIMIT: 90000,
  TAX_RATE: 9,
  SUPPORTED_COUNTRIES: [ // default country
    {
      country_code: 'IN',
      country: 'India',
      product_url: 'https://uniservice.in',
      hero_img_sm: 'hero_sm.png',
      hero_img_big: 'hero.png',
      support_email: 'postman@uniservice.in',
      currency_symbol: '₹ '
    }
  ],
  // FM service provider
  FM_VENDOR_ID: '',
  FM_VENDOR_NAME: '',
  IS_BB_VENDOR: false,
  ATTENDANCE_SHIFT_THRESHOLD: 1.5,
  IS_BACKOFFICE_COMM: false,
  // Security
  SECURITY_POST: '',
  IS_COVID_CHECK_ENABLED: true,
  SMS_FOR_EASYPASS: false,
  COMM_CONFIG: ''
}



// WEBPACK FOOTER //
// ./src/config/app-cfg.js